import { FunctionComponent } from 'react'
import { XmlViewerProps } from './XmlViewer.model'
import './XmlViewer.web-component'

export const XmlViewer: FunctionComponent<XmlViewerProps> = ({ base64 }) => (
  <div className="w-full bg-white p-3 rounded-lg overflow-x-scroll">
    <xml-viewer base64={base64} />
  </div>
)
